import { toTypedSchema } from '@vee-validate/zod'
import { object, string, number, z } from 'zod'
import { asOptionalField, nameValidationSchema, phoneValidationSchema } from './common'
import { emailValidationSchema } from './auth'
import { DEFAULT_MANDATORY_MESSAGE } from '~/constants'

const stepOneSchema = () =>
  object({
    name: nameValidationSchema,
    email: emailValidationSchema,
    country: number({ required_error: DEFAULT_MANDATORY_MESSAGE }).min(1, {
      message: DEFAULT_MANDATORY_MESSAGE,
    }),
    phone: phoneValidationSchema,
  })

export const stepOneTypedSchema = toTypedSchema(stepOneSchema())

const stepTwoSchema = (isMobile: boolean) => {
  const message = isMobile ? ' ' : DEFAULT_MANDATORY_MESSAGE

  return object({
    refer: string({ required_error: ' ' }).min(1, {
      message: ' ',
    }),
    countries: number({
      required_error: ' ',
    })
      .array()
      .nonempty({ message: ' ' }),
    languages: number({ required_error: message }).min(1, {
      message,
    }),
    source_of_knowledge: string({ required_error: message }).min(1, {
      message,
    }),
  })
}

export const stepTwoTypedSchema = (isMobile: boolean) => toTypedSchema(stepTwoSchema(isMobile))

const stepThreeSchema = (isMobile: boolean) => {
  const message = isMobile ? ' ' : DEFAULT_MANDATORY_MESSAGE

  return object({
    social_network: asOptionalField(string()),
    preferred_messenger: string({ required_error: ' ' }).min(1, {
      message: ' ',
    }),
    messenger_username: string({ required_error: message }).min(1, {
      message,
    }),
    other_details: asOptionalField(string()),
  })
}

export const stepThreeTypedSchema = (isMobile: boolean) => toTypedSchema(stepThreeSchema(isMobile))

export type QuestionnaireSchema = z.infer<
  ReturnType<typeof stepOneSchema> & typeof stepTwoSchema & typeof stepThreeSchema
>
